import { render, staticRenderFns } from "./QuemAtende.vue?vue&type=template&id=b544bb8c"
import script from "./QuemAtende.vue?vue&type=script&lang=js"
export * from "./QuemAtende.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports